
    import '/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-agent-tbox-demo-agent-tbox"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.en-US.md?type=demo')
};